import React, { useState, useEffect } from "react";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import { LoadingSpinner } from "../../../components/common/LoadingSpinner";
import { setupData } from "../../../configs/routes";
import { setIntroductionComplete } from "../../../services/userService";
import { pathRoot } from "../Introduction";
import { getVersionInfo } from "../../../services/dashApiService";

const VersionBody = ({ message }) => {
	return message.map((m, index) => {
		return (
			<li key={`message_${index}`} className={`${m.textClass || ""} text-sm`}>
				{m.text}
			</li>
		);
	});
};

const Version = ({ name, message, index }) => {
	return (
		<div key={`version_${index}`} className="w-full ">
			<div className="" dangerouslySetInnerHTML={{ __html: name }}></div>
			<ul className="list-disc ml-8">
				<VersionBody message={message} />
			</ul>
			<hr class="w-48 h-1 mx-auto my-4 bg-gray-100 border-0 rounded md:my-10 dark:bg-gray-700"></hr>
		</div>
	);
};

export function Page3({ onSaveFailure }) {
	const onFinish = () => {
		return new Promise((resolve, reject) => {
			setIntroductionComplete()
				.then(resolve)
				.catch((error) => onSaveFailure(error));
		});
	};

	const headerDetails = {
		title: "Version history",
		currentPage: 3,
		pageCount: 3,
	};

	const [versionInfo, setVersionInfo] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		let didCancel = false;
		setIsLoading(true);
		getVersionInfo()
			.then((result) => {
				setIsLoading(false);
				if (result.success) {
					const data = result.data;
					if (!didCancel) {
						setVersionInfo(data);
					}
				} else {
					console.error(result.err);
				}
			})
			.catch((error) => {
				setIsLoading(false);
				console.error("Error getting contact info: ", error);
			});

		return () => {
			didCancel = true;
		};
	}, []);

	return (
		<SetupDataPageTemplate
			headerDetails={headerDetails}
			backTo={`${pathRoot}/2`}
			nextTo={setupData}
			onClickNext={{ func: onFinish, async: true }}
			nextTextOverride={"Finish"}
		>
			<div className="divide-y divide-white divide-opacity-30">
				<div className="pb-2">
					<h2 className={"text-xl font-bold mb-1"}>Version History</h2>
					<h5 className={"text-md mb-3"}>
						New releases of the app can be found in your device's app store.
					</h5>
				</div>
				<div className="py-2">
					{isLoading ? (
						<LoadingSpinner />
					) : (
						versionInfo.map((v, index) => {
							return (
								<Version name={v.name} message={v.message} index={index} />
							);
						})
					)}
				</div>
			</div>
		</SetupDataPageTemplate>
	);
}
